import * as types from '../mutation-types';
import {
  getOpenBidById,
  getOneStageEvalBidAllEnd,
  getOpenBidStage,
} from '@/api/openBid';
import { getOpenBidState } from '@/api/base';
import { Message } from 'element-gui';

const state = {
  openBidById: {},
  evalBidAllEnd: false,
  openBidStage: 0,
  openBidTwoObj: {
    state: undefined,
  },
  openBidTwoObjTwo: {
    state: undefined,
  },
};

const getters = {
  getOpenBidById: (state) => state.openBidById,
  getEvalBidAllEnd: (state) => state.evalBidAllEnd,
  getOpenBidStage: (state) => state.openBidStage,
  getOpenBidTwoObj: (state) => state.openBidTwoObj,
  getOpenBidNextObj: (state) => state.openBidTwoObjTwo,
};

const actions = {
  // 根据标段id获取全局开标状态
  async getOpenBidByIdStatus({ commit }, obj) {
    await getOpenBidById({
      openBidId: obj.openBidId,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_BIDBYID_STATUS, res.data);
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 获取一阶段评标是否全部结束
  async getOneStageEvalBidAllEnd({ commit }, obj) {
    await getOneStageEvalBidAllEnd({
      domainId: obj.domainId,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_EVALBID_ALLEND, res.data);
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 根据domainId获取开标阶段
  async setOpenBidStage({ commit }, obj) {
    await getOpenBidStage({
      domainId: obj.domainId,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_OPENBID_STAGE, res.data);
      }
    });
  },
  // 获取单阶段或多阶段开标流程信息
  async getOpenBidTwoStatus({ commit }, obj) {
    await getOpenBidState({
      openBidId: obj.openBidId,
      bidSectionId: obj.bidSectionId,
      domainId: obj.domainId,
    }).then((res) => {
      if (res.code == 200) {
        if (obj.single) {
          // 单阶段或者多阶段第一阶段
          commit(types.GET_OPENBIDTWO_STATUS, res.data);
        } else {
          // 多阶段第二阶段
          commit(types.GET_OPENBIDTWOTWO_STATUS, res.data);
        }
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 更新二阶段开标流程信息
  async updateOpenBidTwoStatus({ commit }, obj) {
    await commit(types.GET_OPENBIDTWO_STATUS, obj);
  },
  async getEndByIdStatus({ commit }, obj) {
    commit(types.GET_DECRYPTENDTIME_STATUS, obj);
  },
  async getStartByIdStatus({ commit }, obj) {
    commit(types.GET_DECRYPTSTARTTIME_STATUS, obj);
  },
};

const mutations = {
  [types.GET_BIDBYID_STATUS](state, obj) {
    state.openBidById = obj;
  },
  [types.GET_EVALBID_ALLEND](state, obj) {
    state.evalBidAllEnd = obj;
  },
  [types.GET_OPENBID_STAGE](state, obj) {
    state.openBidStage = obj;
  },
  [types.GET_DECRYPTENDTIME_STATUS](state, obj) {
    if (state.openBidById) state.openBidById.decryptFinish = obj;
  },
  [types.GET_DECRYPTSTARTTIME_STATUS](state, obj) {
    state.openBidById = obj;
  },
  [types.GET_OPENBIDTWO_STATUS](state, obj) {
    state.openBidTwoObj = obj;
  },
  [types.GET_OPENBIDTWOTWO_STATUS](state, obj) {
    state.openBidTwoObjTwo = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
